import { CHANGE_DATE_REQUEST_STAGES } from 'config/constants';
import { useSyncUrlWithState } from './hooks';
import RequestForm from '../RequestForm';
import ReviewRequest from '../ReviewRequest';
import RequestConfirmation from '../RequestConfirmation';
import {
  withChangeDatesRequestFlowContext,
  useChangeDatesRequestFlowContext,
} from '../contextProvider/ChangeDatesRequestFlowContextProvider';

export const ChangeDatesRequestFlow = () => {
  const { booking, stage } = useChangeDatesRequestFlowContext();
  useSyncUrlWithState({ bookingId: booking.id, stage });

  switch (stage) {
    case CHANGE_DATE_REQUEST_STAGES.EDIT:
      return <RequestForm />;
    case CHANGE_DATE_REQUEST_STAGES.REVIEW:
    case CHANGE_DATE_REQUEST_STAGES.SUBMITTING:
      return <ReviewRequest />;
    case CHANGE_DATE_REQUEST_STAGES.CONFIRMED:
      return <RequestConfirmation />;
    default:
      return null;
  }
};

export default withChangeDatesRequestFlowContext(ChangeDatesRequestFlow);
